<template>
    <div class="directChannelConnection">
        <div class="card">
            <img src="@/image/connect-account.svg" alt="" />
            <div class="cardRight">
                <div style="margin-bottom: 30px; font-size: 20px">
                    所有房源已关联
                </div>
                <div>
                    <span style="font-size: 12px">请将房源关联到房间或房型。当有新订单时，系统将根据房源与房间的关系进行落单。房源在完成关联之后才会开启房态、订单和消息同步。
                    </span>
                    <el-link type="primary">了解更多 ></el-link>
                </div>
                <div style="margin-top: 30px">
                    <el-button type="primary" @click="handlerGoTo('/listingLinking')">关联房源</el-button>
                    <el-button type="" @click="handlerGoTo('/allListings')">查看所有房源</el-button>
                </div>
            </div>
        </div>
        <div style="margin: 30px 0; font-size: 20px">已链接的账号</div>
        <div class="tableForm">
            <div class="tableForm">
                <el-input v-model="name" clearable placeholder="请输入账号名称"></el-input>
                <el-button style="margin-left: 10px" type="" @click="getData(1)">渠道</el-button>
            </div>
            <el-button type="primary" @click="handleOpenDiaLog">添加直连账号</el-button>
        </div>

        <el-table :data="tableData"   v-loading="tableLoading" style="width: 100%">
            <el-table-column label="账号" width="180">
                <template slot-scope="scope">
                    {{ scope.row.username }}
                </template>
            </el-table-column>
            <el-table-column label="房源数量" width="180">
                <template slot-scope="scope">  {{ scope.row.housingCount || 0 }} </template>
            </el-table-column>
            <el-table-column label="账号状态" width="180">
                <template slot-scope="scope">
                    <el-tag size="medium" :type="scope.row.status?'success':'danger'">{{scope.row.status?'已连接':'未连接'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="220">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" label="">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handlerBatchAddRoom(scope.$index, scope.row)">{{scope.row.status?'读取房源':'重新授权'}}</el-button>
                    <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除账户</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 20px;">

            <el-pagination :current-page="pageNo" background layout="prev, pager, next" :total="total" @current-change="pageChange">
            </el-pagination>
        </div>

        <el-dialog title="添加直连账号" :visible.sync="dialogVisible" width="840px" :before-close="handleClose">
            <el-row :gutter="12">
                <el-col :span="8">
                    <div class="dialogCard" @click="handlerGetMeituan(0)">
                        <img src="@/image/icon-zhenguo-large.svg" alt="">
                        <div class="cardButton" style="background-color: #ffcf02;">
                            连接
                        </div>
                    </div>
                </el-col>

                <!--<el-col :span="8">-->
                <!--    <div class="dialogCard"  @click="handlerGetMeituan(1)">-->
                <!--        <img src="@/image/icon-xiaozhu-large.svg" alt="">-->
                <!--        <div class="cardButton" style="background-color: #ff5e79;">-->
                <!--            连接-->
                <!--        </div>-->
                <!--    </div>-->
                <!--</el-col>-->

                <!--<el-col :span="8">-->
                <!--    <div class="dialogCard" @click="handlerGetMeituan(2)">-->
                <!--        <img src="@/image/icon-tujia-large.svg" alt="">-->
                <!--        <div class="cardButton" style="background-color: #ed6d01;">-->
                <!--            连接-->
                <!--        </div>-->
                <!--    </div>-->
                <!--</el-col>-->
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import {
    mtRedirectUrl, authorize,
    getAllChannelConnection, addChannelConnection, batchAddRoom, deleteChannelConnection, testUrl2, refresh
} from "@/api/index.js"
export default {
    name: "directChannelConnection",

    data() {
        return {
            name:'',
            tableData: [],
            pageNo:1,
            pageSize:10,
            total:0,
            dialogVisible: false,
            tableLoading:false,
        };
    },

    mounted() {
        if (this.$route.query.customPath)
        {
            addChannelConnection({
                username: localStorage.getItem('nickname'),
                mtToken: localStorage.getItem('accessToken'),
                openId:localStorage.getItem('openId'),
                type:this.$route.query.type || 0,
                status:true

            }).then(res=>{
                if (res.data.code===200)
                {
                    console.log(res.data)
                    this.$message({message:'授权成功!',type:"success"})
                    this.$router.push('/directChannelConnection')
                }

            })
        }
        this.getData();
    },

    methods: {
        getData(pageNo=1)
        {
            this.tableLoading = true;
            this.pageNo = pageNo;
            getAllChannelConnection({
                pageNo:this.pageNo,
                pageSize:this.pageSize,
                name:this.name
            }).then(res=>{
                console.log(res.data)
                if (res.data.code === 200)
                {
                    this.tableData = res.data.data.recode;
                    this.total = res.data.data.total
                    this.tableLoading = false;
                }

            })
        },
        pageChange(index)
        {
          this.getData(index)
        },
        handlerGoTo(path) {
            this.$router.push({ path: path });
        },
        handleOpenDiaLog() {
            this.dialogVisible = true;
        },
        handleClose(){
            this.dialogVisible = false;
        },
        handlerGetMeituan(item){
            if(item==0){
                authorize({
                    uri: 'https://test.youjiaminsu.cn/dist/auth?customPath=directChannelConnection'
                }).then(result => {
                    console.log(result, '获取美团授权地址')
                    window.location = result.data.data;
                })
                return;
            }
            refresh({
                refreshToken: item.mtRefreshToken,
                scope:item.scope,
                openId:item.openId
            }).then(res => {
                if (res.data && res.data.code == 200) {
                   this.$message.success('授权成功')
                    for (let key in res.data.data) {
                        localStorage.setItem(key, res.data.data[key]);
                    }
                    this.$store.commit('setMTConfig', {
                        refreshToken:item.mtRefreshToken,
                        scope:item.scope,
                        openId:item.openId
                    })
                    this.$store.commit("setMtToken", res.data.data.accessToken)
                    addChannelConnection({
                        username: item.username,
                        mtToken: res.data.data.accessToken,
                        openId: res.data.data.openId,
                        mtRefreshToken:item.mtRefreshToken,
                        scope: res.data.data.scope,
                        status:true,
                        id:item.id
                    }).then(res=>{
                        this.getData(1);
                    })

                } else {
                    // this.$message.error(res.data.msg)
                }
            })

            /*authorize({
                uri: 'https://test.youjiaminsu.cn/dist/auth?customPath=directChannelConnection'
            }).then(result => {
                console.log(result, '获取美团授权地址')
                window.location = result.data.data;
            })*/
        },
        handlerBatchAddRoom(index,object)
        {
            if (object.status)
            {
                batchAddRoom({
                    channelId:object.id,
                    pageNow:1,
                    pageSize:999,
                }).then(res=>{
                    console.log(res.data)
                    if (res.data.code ===200)
                    {
                        this.$message({message:'读取成功！',type:"success"})
                    }
                    else
                    {
                        console.log('读取失败！')
                    }
                    this.getData();
                })
            }
            else
            {
                this.handlerGetMeituan(object);
            }

        },
        handleDelete(index,object)
        {
            deleteChannelConnection(object.id).then(res=>{
                if (res.data.code === 200)
                {
                    this.$message({message:'删除成功',type:'success'})
                    this.getData();
                }
            })
        },
        dowload(){
            testUrl2([
                "2023-06-08/5d545b1bf2564010875a4b49872402d7.rar",
                "2023-06-08/72f588d25cda4de0b68fb803a855aa54.rar",
                "2023-06-08/6068b8e129834eb5843da4b9e330434e.rar",
                "2023-06-08/dba12430626742aea74261be774d30b4.rar"
            ]).then(res=>{
                console.log(res)
                const link = document.createElement("a");

                let blob = new Blob([res.data] ); // 文件流处理
                link.style.display = "none"; // 去掉 a 标签的样式
                // 设置链接
                link.href = URL.createObjectURL(blob);
                link.download = '2.zip';
                document.body.appendChild(link);
                // 模拟点击事件
                link.click();
                // 移除创建的 a 标签
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);

            })
        }
    },
};
</script>

<style lang="less" scoped>
.directChannelConnection {
    width: 100%;
    max-height: 100%;
    padding: 30px;

    img {
        height: 100px;
        width: 100px;
    }

    .card {
        background-color: #f9f9f9;
        padding: 30px;
        height: 200px;
        display: flex;
        justify-content: left;
        align-items: center;

        .cardRight {
            margin-left: 30px;
        }
    }

    .tableForm {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .dialogCard {
        width: 260px;
        height: 64px;
        padding: 0 12px;
        border: 1px solid #E1E1E1;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
            width: 132px;
            height: 34px;
        }
        .cardButton{
            padding: 8px;
            color: white;
            border-radius: 10px;
        }
    }
}
</style>
